import React, { useState, useEffect, useContext } from "react";
import { timeoutGet } from "hooks/http";
import { randomString } from "hooks/helper";
import UITopicResults from "ui/UITopicResults";
import useDebounce from "hooks/debounce";

const UISearchTopic = (props) => {
  const [useSearch, setSearch] = useState(undefined);
  const [useList, setList] = useState([]);
  const debouncedSearchTerm = useDebounce(useSearch, 500);

  useEffect(() => {
    const urlPersona =
      "https://2avoul47dg.execute-api.eu-central-1.amazonaws.com/prod";

    debouncedSearchTerm &&
      debouncedSearchTerm !== "" &&
      timeoutGet(urlPersona, {
        type: "r_topic_search",
        topic: debouncedSearchTerm,
        muid: props.muid,
        msgid: 1,
        token: "userToken",
        lat: 0,
        lon: 0,
        range: 100000,
        maxreturned: 10,
      })
        .then((result) => {
          setList(result.list);
        })
        .catch((error) => {});

    return () => {};
  }, [debouncedSearchTerm, props.muid]);

  let content = (
    <div className="UI-login-container">
      <h2 style={{ color: "#555", textDecoration: "none" }}>
        <b>Search for Topic</b>
      </h2>
      <h4 style={{ color: "#555", textDecoration: "none" }}>
        Tap on topic to join
      </h4>
      <input
        className="UI-input"
        type="message"
        placeholder="Searching for..."
        name="search"
        required
        id="search_topic_text"
        autoComplete="off"
        onChange={() => {
          setSearch(document.getElementById("search_topic_text").value);
        }}
      />
      <div id="result_list">
        <UITopicResults
          topicList={[...useList]}
          muid={props.muid}
          mpersona={props.mpersona}
          persona={props.persona}
        />
      </div>
    </div>
  );
  return content;
};

// memo acts like shouldComponentUpdate ... can use without the function, or with a function that returns false if it SHOULD rerender
export default React.memo(UISearchTopic, (prevProps, nextProps) => {
  return prevProps === nextProps;
});
